import { fontList } from '../../core/font-list';
// import {colorListPairs, colorMap,colorListCharts} from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'fontFamily': {
      'default': 'DINNextLTW04-Regular, Open Sans',
      'label': 'fontFamily',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'marginLeft': {
      'default': 20,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 20,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 80,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 100,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'backgroundColor': {
      'default': '#7ab8e2',
      'label': 'backgroundColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconColor': {
      'default': '#7aa874',
      'label': 'iconColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconBorderColor': {
      'default': '#ffffff',
      'label': 'iconBorderColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'iconOpacity': {
      'default': 1,
      'label': 'iconOpacity',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconBorderWidth': {
      'default': 5,
      'label': 'iconBorderWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconX': {
      'default': 40,
      'label': 'iconX',
      'type': 'number',
      'control': 'standard-number',
    },
    'iconY': {
      'default': 40,
      'label': 'iconY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundX': {
      'default': 510,
      'label': 'logoBackgroundX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundY': {
      'default': 85,
      'label': 'logoBackgroundY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundRadius': {
      'default': 60,
      'label': 'logoBackgroundRadius',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoBackgroundColor': {
      'default': '#FFFFFF',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBorderColor': {
      'default': '#908d7f',
      'label': 'logoBorderColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoBackgroundRadiusWidth': {
      'default': 3,
      'label': 'logoBackgroundRadiusWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 80,
      'label': 'logoWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 510,
      'label': 'logoX',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoY': {
      'default': 83,
      'label': 'logoY',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#222222',
      'label': 'logoColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'tilastokeskusTextWidth': {
      'default': 380,
      'label': 'tilastokeskusTextWidth',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusTextX': {
      'default': 60,
      'label': 'tilastokeskusTextX',
      'type': 'number',
      'control': 'standard-number',
    },
    'tilastokeskusTextY': {
      'default': 220,
      'label': 'tilastokeskusTextY',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1X': {
      'default': 40,
      'label': 'titleTextSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1Y': {
      'default': 360,
      'label': 'titleTextSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide1': {
      'default': 'Befolkningen forventes\nat vokse med 279.000\neller 4,8% over de\nnæste ti år',
      'label': 'titleTextSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'titleTextSlide1FontSize': {
      'default': 42,
      'label': 'titleTextSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1LineHeight': {
      'default': 1.2,
      'label': 'titleTextSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide1FontColor': {
      'default': '#1a779e',
      'label': 'titleTextSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide1FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1X': {
      'default': 40,
      'label': 'textSlide1X',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1Y': {
      'default': 450,
      'label': 'textSlide1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'textSlide1': {
      'default': '',
      'label': 'textSlide1',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textSlide1FontSize': {
      'default': 32,
      'label': 'textSlide1FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1LineHeight': {
      'default': 1.4,
      'label': 'textSlide1LineHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textSlide1FontColor': {
      'default': '#FFFFFF',
      'label': 'textSlide1FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'textSlide1FontWeight': {
      'default': 'bold',
      'label': 'textSlide1FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2': {
      'default': 'Befolkning',
      'label': 'titleTextSlide2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2X': {
      'default': 20,
      'label': 'titleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2Y': {
      'default': 44,
      'label': 'titleTextSlide2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'titleTextSlide2FontSize': {
      'default': 32,
      'label': 'titleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleTextSlide2FontColor': {
      'default': '#FFFFFF',
      'label': 'titleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'titleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line1': {
      'default': 'efter aldersgrupper. 2008-2058',
      'label': 'subtitleTextSlide2Line1',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2Line2': {
      'default': 'over 80-årige vokse med 150.000',
      'label': 'subtitleTextSlide2Line2',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2X': {
      'default': 20,
      'label': 'subtitleTextSlide2X',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line1Y': {
      'default': 78,
      'label': 'subtitleTextSlide2Line1Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2Line2Y': {
      'default': 110,
      'label': 'subtitleTextSlide2Line2Y',
      'type': 'number',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontSize': {
      'default': 24,
      'label': 'subtitleTextSlide2FontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'subtitleTextSlide2FontColor': {
      'default': '#1a7cc7',
      'label': 'subtitleTextSlide2FontColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'subtitleTextSlide2FontWeight': {
      'default': 'bold',
      'label': 'subtitleTextSlide2FontWeight',
      'type': 'string',
      'control': 'standard-control',
    },
    'bannerHeight': {
      'default': 133,
      'label': 'bannerHeight',
      'type': 'string',
      'control': 'standard-number',
    },
    'minY': {
      'default': 0,
      'label': 'minY',
      'type': 'string',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 7000,
      'label': 'maxY',
      'type': 'string',
      'control': 'standard-number',
    },
    'steps': {
      'default': 7,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'unitText': {
      'default': 'Tusinde personer',
      'label': 'unitText',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitFontFamily': {
      'default': 'DINNextLTW04-Regular, Open Sans',
      'label': 'unitFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'xAxisLabelFontFamily': {
      'default': 'DINNextLTW04-Regular, Open Sans',
      'label': 'xAxisLabelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'unitTextOffsetY',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'labelSpaceY',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'labelSpaceX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#7f7f7f',
      'label': 'labelColor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'xAxisLabelFontSize': {
      'default': 20,
      'label': 'labelFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'DINNextLTW04-Regular, Open Sans',
      'label': 'labelFontFamily',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontAnchor': {
      'default': 'start',
      'label': 'labelFontAnchor',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'labelOffsetY',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'labelOffsetX',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'labelDecimalsY',
      'type': 'number',
      'control': 'standard-number',
    },
    'leftLabelX': {
      'default': '2008',
      'label': 'leftLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2017',
      'label': 'rightLabelX',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#979797',
      'label': 'axisStroke',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 1,
      'label': 'axisStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#0574B0'],
      'label': 'lineStrokes',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'lineStrokeWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Miter'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Miter'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Round'
        }
      ],
      'control': 'standard-select',
    },
    'formatLocale': {
      'default': {
        'key': 'fi',
        'value': 'fi',
        'label': 'Suomen kieli'
      },
      'label': 'Taal',
      'type': 'string',
      'values': [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        },
        {
          'key': 'fi',
          'value': 'fi',
          'label': 'Suomen kieli'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'legendMarginTop': {
      'default': 20,
      'label': 'legendMarginTop',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendRowHeight': {
      'default': 16,
      'label': 'legendRowHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendVerticalSpacing': {
      'default': 12,
      'label': 'legendVerticalSpacing',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendHorizontalSpacing': {
      'default': 20,
      'label': 'legendHorizontalSpacing',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendColumns': {
      'default': 3,
      'label': 'legendColumns',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendMarkerHeight': {
      'default': 10,
      'label': 'legendMarkerHeight',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendMarkerWidth': {
      'default': 15,
      'label': 'legendMarkerWidth',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendMarkerMargin': {
      'default': 10,
      'label': 'legendMarkerMargin',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontFamily': {
      'default': 'DINNextLTW04-Regular, Open Sans',
      'label': 'legendFontFamily',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'legendFontSize': {
      'default': 16,
      'label': 'legendFontSize',
      'type': 'numeric',
      'control': 'standard-number',
    },
  },
  'timings': {
    'pauseSlides': {
      'default': 3,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 1,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 4,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide3Animation': {
      'default': 3,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 2,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['', '0-19 år', '20-49 år', '50-64 år', '65-79 år', '80+ år'], ['2008', 1344.18, 2186.286, 1092.284, 628.001, 225.04 ], ['2018', 1306.55, 2224.358, 1134.219, 859.369, 256.694 ], ['2028', 1342.233, 2233.363, 1160.644, 917.483, 406.721 ], ['2038', 1439.972, 2289.426, 1011.117, 1027.28, 497.881 ], ['2048', 1432.528, 2314.08, 1081.286, 962.824, 611.531 ], ['2058', 1441.828, 2375.504, 1146.249, 931.33, 665.758 ]],
    'columnLimitMin': 1,
    'columnLimitMax': 7,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 1000,
    'rowLabelNumber': 1,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'backgroundColor', 'iconColor', 'iconOpacity', 'iconX', 'iconY', 'titleTextSlide1', 'titleTextSlide1Y', 'textSlide1', 'textSlide1Y'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': [],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-dst-triptych-line-hor-steps/social.params.ts